import { SideCart } from '../checkout'
import { Cart } from '../checkout/cart'

const el = {
  root: document.querySelector<HTMLDivElement>('.search-popup'),
  content: document.querySelector<HTMLDivElement>('.search-popup__content'),
  triggers: document.querySelectorAll<HTMLButtonElement>('.search-trigger'),
  overlay: document.querySelector<HTMLDivElement>('.overlay'),
  form: document.querySelector<HTMLFormElement>('.search-popup__form'),
  input: document.querySelector<HTMLInputElement>('.search-popup__input'),
  suggestionsContainer: document.querySelector<HTMLDivElement>(
    '.search-popup__suggestions-container'
  ),
  suggestionsPopupResults: document.querySelector<HTMLDivElement>(
    '.search-popup__suggestions'
  ),
  suggestionsPopupData: document.querySelector<HTMLDivElement>(
    '.search-popup-suggestion-data'
  ),
  linkElement: document.querySelector<HTMLAnchorElement>('.search-popup__link'),
  closeButton: document.querySelector<HTMLButtonElement>('.search-popup__close-button'),
}

let timeoutId = null
const debounce =
  (callback, wait) =>
  (...args: any) => {
    window.clearTimeout(timeoutId)
    timeoutId = window.setTimeout(() => {
      callback(...args)
    }, wait)
  }

export const Search = {
  init: async () => {
    if (!el.root) return
    el.triggers.forEach((target) => target.addEventListener('click', Search.togglePopup))

    if (el.overlay) el.overlay.addEventListener('click', Search.onClose)
    if (el.closeButton) el.closeButton.addEventListener('click', Search.onClose)
    if (el.content) el.content.addEventListener('click', (e) => e.stopPropagation())

    el.root.addEventListener('click', Search.onClose)

    el.input.addEventListener('input', Search.onInputChange)
    window.addEventListener('keydown', Search.keydown)
  },

  keydown: (e) => {
    const { key } = e

    if (key === 'Escape') {
      Search.onClose()
    }

    if (key === 'Enter' && e.target.classList.contains('search-popup__input')) {
      e.preventDefault()
      window.location.href = `/leit/?q=${el.input.value}`
    }
  },

  onInputChange: (e) => {
    const debounceMe = debounce(() => Search.sendData(), 400)

    if (e.target.value.length >= 2) {
      debounceMe()
    }

    if (e.target.value.length < 1) {
      Search.closeSuggestions()
    }
  },

  sendData: async () => {
    const url = el.form.getAttribute('action')

    try {
      const response = await fetch(`${url}?q=${el.input.value}&lang=is-IS`, {
        method: 'get',
      })
      const json = await response.json()

      const { result, success, total, linkText, url: linkUrl } = json

      if (total < 1 || success == false) {
        Search.closeSuggestions()
      } else if (result && success == true && total > 0) {
        const data = el.suggestionsPopupData

        el.suggestionsPopupResults.innerHTML = result

        const addToBasketForms =
          el.suggestionsPopupResults.querySelectorAll<HTMLFormElement>(
            '.add-to-cart-form'
          )
        addToBasketForms.forEach((basketForm) => {
          basketForm.action = '/'
        })

        const addToCartForms =
          document.querySelectorAll<HTMLFormElement>('.add-to-cart-form')
        addToCartForms.forEach((target) => {
          target.addEventListener('submit', Cart.addToCart)
        })

        const cards = el.suggestionsPopupResults.querySelectorAll('.product-card')

        if (cards && cards.length > 0) {
          for (const card of cards as any) {
            card.classList.add('product-card--search')
          }
        }

        el.suggestionsPopupData = data
        el.linkElement.innerHTML = linkText
        el.linkElement.href = linkUrl

        Search.openSuggestions()
      }
    } catch (e) {
      Search.closeSuggestions()
    }
  },

  openSuggestions: () => {
    if (el.suggestionsContainer) {
      el.suggestionsContainer.classList.add('search-popup__suggestions-container--open')
    }
  },

  closeSuggestions: () => {
    el.suggestionsPopupResults.innerHTML = ''

    if (el.suggestionsContainer) {
      el.suggestionsContainer.classList.remove(
        'search-popup__suggestions-container--open'
      )
    }
  },

  onOpen: () => {
    document.body.classList.add('h-disable-scroll')
    if (el.overlay) {
      el.overlay.classList.add('overlay--visible')
      el.input.focus()
    }

    SideCart.closeMenu(true)

    if (el.root) {
      el.root.classList.add('search-popup--visible')
      el.input.focus()
    }
  },

  onClose: () => {
    document.body.classList.remove('h-disable-scroll')

    if (el.overlay) el.overlay.classList.remove('overlay--visible')
    if (el.root) el.root.classList.remove('search-popup--visible')

    el.input.value = ''
    Search.closeSuggestions()
  },

  togglePopup: () => {
    if (el.root.classList.contains('search-popup--visible')) {
      Search.onClose()
      return
    }
    Search.onOpen()
  },

  onPopupOpen: () => {
    document.body.classList.add('h-disable-scroll')
    if (el.overlay) el.overlay.classList.add('overlay--visible')
    if (el.root) el.root.classList.add('search-popup--visible')

    Search.closeSuggestions()
  },
}
